/*fx.ns("shared.popups", class IACreationPopup extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data);
        this.contentWidth = 400;
        this.contentHeight = 140;
        this._count = 0;
        this._photoIndex = 0;
    }


    create()
    {
        super.create();
        this._text1 = new fx.components.Text({text:fx.text("Analyse de vos photos"),className:"text center"});
        this._text2 = new fx.components.Text({text:fx.text("Recherche des moments clés"),className:"text center"});
        this._text3 = new fx.components.Text({text:fx.text("Création de votre album"),className:"text center"});
        this.addChild(this._text1);
        this.addChild(this._text2);
        this.addChild(this._text3);

        this._progress = new fx.components.Text({className:"progress center"});
        this.addChild(this._progress);

        this._finishedImage = new fx.components.Image({data : fx.get("assets").checkedIcon, className : "finished"});
        this._finishedImage.visibleAtStart = false;
        this.addChild(this._finishedImage);
    }

    onReady()
    {
        super.onReady();
        this.repeat(this._updatePhoto, 100);

        this.on("finished", this.onFinished, fx.service("AIService"));
    }


    _updatePhoto()
    {
        if (!this._centerClassAdded)
        {
            this.personImage.addClass("center");
            this._centerClassAdded = true;
        }
        
        this.personImage.cover = true;
        this.personImage.src = this.data.photos.getItemAt(this._photoIndex++).thumb;

        if (fx.service("AIService").progress <= 70)
            this._setStep(1)
        else
        if (fx.service("AIService").progress <= 90)
            this._setStep(2);
        else
        if (fx.service("AIService").progress <= 100)
            this._setStep(3);
        
        this._progress.text = fx.service("AIService").progress + "%";
        
        if (this._photoIndex >= this.data.photos.length)
            this._photoIndex = 0;
    }

    
    _setStep(val)
    {
        if (val == this._step)
            return;
        
        this._step = val;

        switch (this._step)
        {
            case 1 : 
                this._text1.addClass("bigger");
                this._text2.removeClass("bigger");
                this._text3.removeClass("bigger");
                break;

            case 2 : 
                this._text1.removeClass("bigger");
                this._text2.addClass("bigger");
                this._text3.removeClass("bigger");
                break;

            case 3 : 
                this._text1.removeClass("bigger");
                this._text2.removeClass("bigger");
                this._text3.addClass("bigger");
                break;

            case 4 : 
                this._text1.addClass("bigger central");
                this._text1.text = fx.text("Votre album est prêt !");
                this._text2.hide();
                this._text3.hide();
                this.personImage.hide();
                this.circlesBox.hide();
                this._progress.hide();
                this._finishedImage.show();

                this.delay(this.close, 3000);
                break;
        }
    }


    onFinished()
    {
        this.repeat(this._updatePhoto, null);

        this._setStep(4);
    }
    


});
*/